module.exports = __webpack_public_path__ + "img/anti-pirataria-1024x94.722a21ae.png";